import axios from 'axios';
import ErrorHandler from './ErrorHandler';
import store from './store';

if (process.env.NODE_ENV === 'development') {
    axios.defaults.withCredentials = true;
}

const get_headers = (rest = {}) => {
    const headers = {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
        Accept: 'application/json',
        ...rest,
    };

    return headers;
};

export const getData = async (address, params = {}) => {
    const request = await axios({
        url: process.env.VUE_APP_API_URL + '/cms/' + address,
        withCredentials: false,
        params,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
            Accept: 'application/json',
        },
        method: 'GET',
    }).catch((error) => error.response);

    if (request && request.status === 401) {
        store.dispatch('logout');
    }

    return request;
};

export const deleteItem = async (address, raw) => {
    const request = await axios({
        url:
            raw === true
                ? address
                : process.env.VUE_APP_API_URL + '/cms/' + address,
        withCredentials: false,
        headers: get_headers(),
        method: 'DELETE',
    }).catch(ErrorHandler);

    if (request && request.status === 401) {
        store.dispatch('logout');
    }

    return request;
};

export const updateData = async (address, content) => {
    const request = await axios({
        url: process.env.VUE_APP_API_URL + '/cms/' + address,
        withCredentials: false,
        headers: get_headers(),
        method: 'PUT',
        data: content,
    }).catch(ErrorHandler);

    if (request && request.status === 401) {
        store.dispatch('logout');
    }

    return request;
};
export const storeData = async (address, content) => {
    const request = await axios({
        url: process.env.VUE_APP_API_URL + '/cms/' + address,
        withCredentials: false,
        headers: get_headers(),
        method: 'POST',
        data: content,
    }).catch(ErrorHandler);

    if (request && request.status === 401) {
        store.dispatch('logout');
    }

    return request;
};

export const uploadData = async (address, content) => {
    const request = await axios({
        url: process.env.VUE_APP_API_URL + '/cms/' + address,
        withCredentials: false,
        headers: get_headers({ 'Content-Type': 'multipart/form-data' }),
        method: 'POST',
        data: content,
    }).catch(ErrorHandler);

    if (request && request.status === 401) {
        store.dispatch('logout');
    }

    return request;
};
